import { render, staticRenderFns } from "./xfejAuth.vue?vue&type=template&id=1163c5ff&scoped=true&"
import script from "./xfejAuth.vue?vue&type=script&lang=js&"
export * from "./xfejAuth.vue?vue&type=script&lang=js&"
import style0 from "./xfejAuth.vue?vue&type=style&index=0&id=1163c5ff&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1163c5ff",
  null
  
)

export default component.exports